// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-DownloadFileCreatedAt_cls1__UvBJJ","cls2":"StyledComponents-DownloadFileCreatedAt_cls2__3n2LN StyledComponents-DownloadFileCreatedAt_cls1__UvBJJ"};